import { useSlots, computed, createBlock, openBlock, unref } from "vue";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import { VIcon } from "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                     */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                            */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import { usePortalIcons } from "../../plugins/banza/icons.js";
const _sfc_main = {
  __name: "BanzaIcon",
  props: {
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: [String, Number],
      default: 24
    }
  },
  setup(__props) {
    const portalIcons = usePortalIcons();
    const props = __props;
    const slots = useSlots();
    const icon = computed(() => {
      var _a, _b;
      if (props.icon) {
        return props.icon.trim();
      }
      const slotContent = (_a = slots.default) == null ? void 0 : _a.call(slots);
      if (slotContent && slotContent.length > 0) {
        return ((_b = slotContent[0].children) == null ? void 0 : _b.trim()) || "";
      }
      return "";
    });
    const isIconify = computed(() => {
      var _a;
      return ((_a = icon.value) == null ? void 0 : _a.includes(":")) && !portalIcons.some((set) => icon.value.startsWith(`${set.prefix}:`));
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(VIcon, {
        icon: unref(isIconify) ? `iconify:${unref(icon)}` : unref(icon),
        color: __props.color,
        size: __props.size
      }, null, 8, ["icon", "color", "size"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
